import { InvalidArgumentError } from '#common/types';
export const getSettingFromList = (settings, name) => {
    const setting = settings.find((x) => x.fullName().name === name);
    if (!setting) {
        return undefined;
    }
    return setting;
};
export const settingFullNameToString = (fullName) => {
    return `${fullName.target}.${fullName.name}`;
};
export const settingFullNameFromString = (fullName) => {
    const parsed = fullName.split('.');
    if (parsed.length !== 2) {
        throw new InvalidArgumentError(`Invalid setting full name: ${fullName}`);
    }
    return { target: parsed[0], name: parsed[1] };
};
